/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// uploadPdfAndImage
// UPLOADPDFANDIMAGE
const CREATEPROJECT= createAsyncThunk(
  "createProject/createProject",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const createProjectSlice = createSlice({
  name: "createProjectSlice",
  initialState: {
    createProject: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfcreateProject: (state) => {
        state.createProject.loading = false
        state.createProject.error = false
        state.createProject.data = []
        state.createProject.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(CREATEPROJECT.fulfilled, (state, action) => {
      state.createProject = {
        ...state.createProject,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(CREATEPROJECT.pending, (state, action) => {
      state.createProject = {
        ...state.createProject,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(CREATEPROJECT.rejected, (state, action) => {
      state.createProject = {
        ...state.createProject,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const createProjectAction = {
    CREATEPROJECT,
};

export { createProjectAction };
export default createProjectSlice.reducer;
export const {setInitialStateOfcreateProject} = createProjectSlice.actions